import { CircularProgress } from '@mui/material'
import { useParams } from 'react-router'
import PrintableScreeningReportComponent from 'src/mentor/components/ScreeningReportMakingPage/printableReport/PrintableScreeningReportComponent'
import TherapyReportPreview from 'src/mentor/components/TherapyReportMakingPage/components/TherapyReportPreview'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import useSupportReportsViewer from 'src/supportPortal/views/supportReportsViewer/hooks/useSupportsView'

export default function SupportReportsViewer() {
  const { bookedEventSlug } = useParams()
  const { bookedEventInfo, emrSectionDataList, screeningReportData, therapyReportData, loading } =
    useSupportReportsViewer({ bookedEventSlug })

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader heading="View and Download Reports" />
      {loading ? (
        <div className="d-flex w-100 justify-content-center h-100 align-items-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="w-100" style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
          {screeningReportData && (
            <PrintableScreeningReportComponent
              emrSectionDataList={emrSectionDataList}
              bookedEventInfo={bookedEventInfo}
              templateData={screeningReportData?.template}
              isAlwaysPrinting
              report={screeningReportData?.report}
              sendReportToTriggeringPractitionerApiSignature="/api/secure/cc/support/practitioner-supervisor/emr-reports/screening-report/send-to-triggering-practitioner"
            />
          )}
          {therapyReportData && (
            <TherapyReportPreview
              hideInUI={false}
              isAlwaysPrinting
              report={therapyReportData?.report}
              templateData={therapyReportData?.template}
              setReport={() => {}}
              sendReportToTriggeringPractitionerApiSignature="/api/secure/cc/support/practitioner-supervisor/emr-reports/therapy-report/send-to-triggering-practitioner"
              //   therapyDate={therapyDate}
            />
          )}
          {/* {prescriptionReport && <PrescriptionReportViewer prescriptionReport={prescriptionReport} />} */}
        </div>
      )}
    </div>
  )
}
